module.exports = __webpack_public_path__ + "img/7.c016ede0.jpg";